module.exports = "<div class=\"container w-100 animated fadeIn\">\n  <div class=\"row align-items-start border\">\n    <div class=\"col border-left-0\">\n      <app-login-form (onSuccess)=\"go()\"></app-login-form>\n    </div>\n    <div class=\"col bg-gray\">\n      <app-register-form (onSuccess)=\"go()\"></app-register-form>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/register-login/register-login.component.html
// module id = 1087
// module chunks = 0